export const FETCH_SEARCH = 'search/FETCH_SEARCH';
